export default __webpack_public_path__ + "static/media/37k.05b5be20.yaml";